import type { WireFrameExtractDialogAction } from './types';

export const WireFrameExtractMessageService = Symbol.for('WireFrameExtractMessageService');

export interface WireFrameExtractMessageService {
    showSuccessMessage(action: WireFrameExtractDialogAction): void;
    showCountOverLimitError(): void;
}
